import React from "react";
import { SOCIAL_MEDIA_URLS } from "../../constants";
import P from "../P/P";
import LanguageSwitcher from "../LanguageSwitcher/LanguageSwitcher";
import {
  NavWrapper,
  SocialsContainer,
  SocialElement,
  UtilsContainer,
  UtilElement,
} from "./UpperNav.styles";
import FacebookIcon from "../../icons/FacebookIcon";
import InstagramIcon from "../../icons/InstagramIcon";
import YoutubeIcon from "../../icons/YoutubeIcon";
import GlobeIcon from "../../icons/GlobeIcon";

function UpperNav() {
  return (
    <NavWrapper>
      <SocialsContainer>
        <SocialElement
          href={SOCIAL_MEDIA_URLS.facebook}
          target="_blank"
          rel="noreferrer"
        >
          <FacebookIcon />

          <P>Facebook</P>
        </SocialElement>

        <SocialElement
          href={SOCIAL_MEDIA_URLS.instagram}
          target="_blank"
          rel="noreferrer"
        >
          <InstagramIcon />
          <P>Instagram</P>
        </SocialElement>

        <SocialElement
          href={SOCIAL_MEDIA_URLS.youtube}
          target="_blank"
          rel="noreferrer"
        >
          <YoutubeIcon />
          <P>Youtube</P>
        </SocialElement>
      </SocialsContainer>

      <UtilsContainer>
        <UtilElement>
          <GlobeIcon />
          <LanguageSwitcher />
        </UtilElement>
      </UtilsContainer>
    </NavWrapper>
  );
}

export default UpperNav;
